import { AuthContext, type AuthContextValue } from '@/providers/AuthProvider'
import { useContext } from 'react'

export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuthContext must be used inside AuthProvider')
  }
  return context
}

export function useAuth() {
  return useAuthContext()
}
